export enum DashboardPermissionContext {
  FEATURE_FLAG = 'featureFlag',
  SHOR_TERM_FLAG = 'shortTermFeatureFlag',
  MERCHANT = 'merchant',
}
